/**
 * The `procedures_defnoreturn` OVERRIDE -- the function wrapper block every generated body hangs from.
 *
 * Extracted verbatim from blockly-interface.component.ts, where it sat inside `newBlocklyFunction`.
 * That method is 1500 lines but is otherwise the DOM workspace bootstrap: `Blockly.inject`, the toolbox,
 * the change listener. This was the ONLY block definition in it, and the only part of it a headless
 * runner needs -- headless replaces `Blockly.inject(div, ...)` with `new Blockly.Workspace()`.
 *
 * `NonEditableFieldTextInput` makes the function NAME read-only: the name is owned by the page
 * (`page.functions[].name`, and the componentDataBinding that points at it), never by a canvas click.
 *
 * NOTHING REMOVED -- `newBlocklyFunction` still registers this block, now by calling here.
 * See docs/plans/background-generation-pipeline.md.
 */
import * as Blockly from 'blockly-tradais';

export function registerProcedureBlock() {
    // Override the default 'procedures_defnoreturn' block

    class NonEditableFieldTextInput extends Blockly.FieldTextInput {
      constructor(text: any) {
        super(text);
      }

      // Override the showEditor_ method to disable editing
      override showEditor_() {
        // Do nothing to disable the text input editor
      }
    }

    Blockly.Blocks['procedures_defnoreturn'] = {
      init: function () {
        this.appendDummyInput()
          .appendField('function')
          //   .appendField(new Blockly.FieldLabel('${defaultFunctionName}'), 'NAME');
          .appendField(
            new NonEditableFieldTextInput('${defaultFunctionName}'),
            'NAME'
          );
        this.appendStatementInput('STACK').setCheck(null).appendField('do');
        this.setColour(290);
        this.setTooltip('');
        this.setHelpUrl('');
        this.setStyle('procedure_blocks');
      },
    };
}
